import Validation from 'src/components/Validation'

// Apple Pay / Google Pay skip the donor's contact fields, so the email
// the wallet hands back would otherwise meet Order's checks (75
// characters + EmailValidator) for the first time on saveDraft, as a
// field error with no field on screen to show it against. Same rules as
// the contact fields, minus `required`: the wallet always asks for an
// email, and a blank one is the server's call anyway (a logged-in donor
// doesn't need one). The donor can't fix the address in our form, so
// the message names it and points them back at the wallet or another
// method.
//
// Callers trim first and send the trimmed value: Order strips ASCII
// whitespace only, and would still reject the trailing no-break space
// that the email rule's trim() lets through.
const walletEmailError = ({ i18n, email, wallet }) => {
  if (!email) return null

  const { valid } = Validation(i18n).validate(
    { email },
    { fieldSet: { email: { maxLength: 75, email: true } } },
  )
  if (valid) return null

  // A left-to-right mark on each side of the address. In an RTL locale a
  // dot at either end would otherwise take the sentence's direction and
  // show on the wrong side (user@example.com. as .user@example.com), which
  // misplaces the very problem the message is pointing at. No effect in
  // LTR locales.
  const displayed = `\u200E${email}\u200E`
  return { base: [ i18n.t('errors.wallet_email_invalid', { email: displayed, wallet }) ] }
}

export default walletEmailError
